module.exports = __webpack_public_path__ + "static/media/Lakeview-Bylaws.2ab39167.pdf";